import { render, staticRenderFns } from "./WaysTab.vue?vue&type=template&id=30bc234b&"
import script from "./WaysTab.vue?vue&type=script&lang=js&"
export * from "./WaysTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports